import { render, staticRenderFns } from "./EmailAccountsView.vue?vue&type=template&id=1938c906&"
import script from "./EmailAccountsView.vue?vue&type=script&lang=js&"
export * from "./EmailAccountsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1938c906')) {
      api.createRecord('1938c906', component.options)
    } else {
      api.reload('1938c906', component.options)
    }
    module.hot.accept("./EmailAccountsView.vue?vue&type=template&id=1938c906&", function () {
      api.rerender('1938c906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/email/EmailAccountsView.vue"
export default component.exports